import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { ButtonPrimary, ButtonClean } from 'front-end/src/components'

import MembersSelector, {
  IMembersSelectorUser,
  IMembersSelectorMembers
} from '../../../../components/common/members-selector/MembersSelector'
import { Modal } from '../../../../components/common/modal/Modal'
import { remove } from 'lodash'
import {
  useSuggestCollaboratorsQuery,
  useAddCollaboratorsMutation
} from './AddCollaboratorsModal.codegen'

interface IProps {
  show: boolean
  dashboardId: number
  onHide: () => void
  refetch: () => void
}

const AddCollaboratorsModal = ({
  show,
  dashboardId,
  onHide,
  refetch: refetchPage
}: IProps) => {
  const [state, setState] = useState<{
    usersSelected: IMembersSelectorUser[]
  }>({
    usersSelected: []
  })

  const { data, loading, refetch } = useSuggestCollaboratorsQuery({
    variables: {
      id: dashboardId
    }
  })

  const [addCollaboratorsFn] = useAddCollaboratorsMutation()

  const addMember = (user: IMembersSelectorUser) => {
    if (!state.usersSelected.find((u) => u.id === user.id)) {
      setState({
        ...state,
        usersSelected: [...state.usersSelected, user]
      })
    }
  }

  const removeMember = (user: IMembersSelectorUser) => {
    const copy = [...state.usersSelected]
    remove(copy, (u) => u.id === user.id) // mutable

    setState({
      ...state,
      usersSelected: copy
    })
  }

  return (
    <Modal
      header={t`Add collaborator to dashboard`}
      subHeader={t`Only another admins can be invited`}
      onHide={onHide}
      show={show}
      controls={[
        <ButtonClean key={1} onClick={onHide}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonPrimary
          key={2}
          onClick={async () => {
            await addCollaboratorsFn({
              variables: {
                id: dashboardId,
                userIds: state.usersSelected.map((u) => u.id)
              }
            })
            onHide()
            refetchPage()
          }}
          isLoading={false}
        >
          <Trans>Invite collaborators</Trans>
        </ButtonPrimary>
      ]}
    >
      <MembersSelector
        onQueryChange={(value) => {
          refetch({
            id: dashboardId,
            search: value
          })
        }}
        onAdd={(user) => {
          user && addMember(user)
        }}
        onRemove={(user) => {
          user && removeMember(user)
        }}
        isSearching={loading}
        membersSearched={
          {
            users: data?.admin?.dashboard?.suggestCollaborators || [],
            groups: []
          } as IMembersSelectorMembers
        }
        membersSelected={{ users: state.usersSelected, groups: [] }}
      />
    </Modal>
  )
}

export default AddCollaboratorsModal
